<template>
    <header>
        <button class="btn-icon btn-toggle-music" v-if="showMusicButton">
            <SvgNote></SvgNote>
            <span class="sr-only">Musique</span>
        </button>

        <router-link :to="{name: 'home-with-lang', params:{ lang }}" class="btn-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 65"><path fill-rule="evenodd" d="M55.07 61.72c-.26 1.11-5.36 4.04-12.45 1.77-3.32-1.07-1.21-11.6-2.7-13.5-1.16-1.48-11.14-3.17-14.39.1-2.03 2.04.06 12.43-4.3 13.7-6.45 1.87-7.8.24-8.79-.05-1.89-.54-4.05-.8-3.86-12.14.18-11.3 1.3-19.76 1.3-19.76s-4.36 3.08-7.34 2.54c-2.97-.54-4.34-2.61 1.6-12.33C10.09 12.31 30.62-1.94 34.41.22c5.21 2.97 15.44 8.87 25.27 22.58 4.65 6.48 6.39 14.69-1.81 11.02-3.74-1.68-3.64-1.96-3.64-1.96s2.22 24.04.84 29.87v-.01Z" clip-rule="evenodd"/></svg>
            <span class="sr-only">Accueil</span>
        </router-link>
    </header>

    <div class="game-2 page-box" v-if="showCharactersSelect">
        <h1 class="page-box-title">Choisis l'ami qui t'accompagnera</h1>

        <div class="box-content">
            <Cards>
                <template v-for="(item, i) in game2_data">
                    <Card
                        :label="item.name"
                        :image="`/images/${item.image}`"
                    >
                        <template v-slot:header>
                            <h2 class="card-title">{{ item.title }}</h2>
                        </template>
                        <template v-slot:button>
                            <button class="btn-primary btn-choose" @click="() => selectCharacter(item)">Choisir</button>
                        </template>
                    </Card>
                </template>
            </Cards>
        </div>
    </div>

    <div class="game-2 game-content" v-if="showMusicSelect">
        <speech-bubble>
            <template #default>
                <div class="content-choice">
                    <div class="choice">
                        <SoundButton
                            id="1"
                            file="/audio/sample-1.mp3"
                        />
                        <span class="choice-label">Prélude à l'après-midi d'un faune (DeBussy)</span>
                        <button class="btn-primary btn-choose" @click="() => selectMusic(1)">Choisir</button>
                    </div>
                    <div class="choice">
                        <SoundButton
                            id="2"
                            file="/audio/sample-2.mp3"
                        />
                        <span class="choice-label">Rêverie et petite valse (Caplet)</span>
                        <button class="btn-primary btn-choose" @click="() => selectMusic(2)">Choisir</button>
                    </div>
                    <div class="choice">
                        <SoundButton
                            id="3"
                            file="/audio/sample-3.mp3"
                        />
                        <span class="choice-label">Two Rondos for Piano, Op. 51: Rondo in C Major, No. 1</span>
                        <button class="btn-primary btn-choose" @click="() => selectMusic(3)">Choisir</button>
                    </div>
                </div>
            </template>
        </speech-bubble>

        <div class="character">
            <img :src="`/images/${character.image}`" width="250" alt="" />
        </div>
    </div>

    <div class="game-2 game-content" v-if="showIntro">
        <speech-bubble :handleClickNext="startGame">
            <template #default>
                <div class="content-text">
                    <div class="inner">
                        <p>Suis les instructions à l’écran pour te détendre en compagnie d’Alto le lynx et de ta musique préférée.</p>
                    </div>
                </div>
            </template>
        </speech-bubble>

        <div class="character">
            <img :src="`/images/${character.image}`" width="250" alt="" />
        </div>
    </div>

    <div class="game-2 game-content" v-if="showGame">

        <speech-bubble class="calm" :handleClickNext="endGame">
            <template #default>
                <div class="content-text">
                    <div class="inner">
                        <p>Inspire profondément par le nez...</p>
                    </div>
                </div>
            </template>
        </speech-bubble>

        <div class="character">
            <img :src="`/images/${character.image}`" width="250" alt="" />
        </div>
    </div>

    <div class="game-2 page-box reward" v-else-if="showReward">
        <h1 class="page-box-title">Félicitations!</h1>

        <div class="box">
            <p>Tu as débloqué le masque d'Alto!</p>
            <img src="/images/rewards/mask-alto-calm.png" />
            <p>Demande à un adulte de se diriger dans la <router-link :to="{name: 'parentsArea', params:{ lang }}">ZONE PARENTS</router-link> pour le faire imprimer!</p>
        </div>
    </div>

    <nav class="nav-prevnext" v-if="showReward">
        <button @click="endScreen" class="btn-icon btn-next">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 66 52"><path fill-rule="evenodd" d="M2.73 14.54c-1.86.44-3.28 2.89-2.52 9C.97 29.65.16 34.78.7 36.69c.55 1.91 1.07 3.63 12.26 1.18s19.96-4.95 19.96-4.95-3.11 13.5-2.56 16.5c.55 3 2.63 4.38 12.46-1.62 9.82-6 24.22-20.38 22.04-24.2-3-5.27-8.95-10.14-22.8-20.07-6.55-4.7-11.95-5.27-11.13 1.82.82 7.09 1.98 12.77 1.98 12.77S8.62 13.15 2.74 14.55l-.01-.01Z" clip-rule="evenodd"/></svg>
        </button>
    </nav>

    <div class="game-2 game-content" v-if="showReplay">

        <speech-bubble class="calm">
            <template #default>
                <div class="content-text">
                    <div class="inner">
                        <p>J'espère que tu t'es bien détendu en compagnie d'Alto!</p>
                    </div>
                </div>
            </template>
        </speech-bubble>

        <nav role="navigation" class="big-buttons">
            <button @click="startGame" class="btn-image">
                <h2 class="btn-image-title">Refaire l'exercice</h2>
                <img :src="`/images/btn-playagain-game2-${character.slug}.jpg`" width="348" height="398" alt="" />
            </button>
            <button @click="replay" class="btn-image">
                <h2 class="btn-image-title">Choisir un autre ami</h2>
                <img src="/images/amis-plein-astuces.jpg" width="348" height="398" alt="" />
            </button>
        </nav>
    </div>

</template>

<script>
    import Cards from "../components/Cards";
    import Card from "../components/Card";
    import SpeechBubble from "../components/SpeechBubble";
    import SoundButton from "../components/SoundButton";
    import SvgNote from "../components/SvgNote";

    export default {
        name: "Game2",
        components: [ 'Cards', 'Card', 'SpeechBubble', 'SoundButton', 'SvgNote' ]
    }
</script>

<script setup>

    import { useMainStore }     from "../stores/main";
    import { storeToRefs }      from "pinia";
    import { computed, ref } from "vue";

    let store = useMainStore();
    const { lang } = storeToRefs(store);
    const { game2_data } = store;

    let character = ref(false);
    let music = ref(false);
    let stage = ref('selectCharacter');

    let showCharactersSelect = computed ( () => stage.value === 'selectCharacter' );
    let showMusicSelect = computed ( () => stage.value === 'selectMusic' );
    let showIntro = computed ( () => stage.value === 'intro' );
    let showMusicButton = computed ( () => stage.value === 'game_start' );
    let showGame = computed ( () => stage.value === 'game_start' );
    let showReward = computed ( () => stage.value === 'game_end' );
    let showReplay = computed ( () => stage.value === 'outro' );

    function selectCharacter(selected) {
        character.value = selected;
        stage.value = 'selectMusic';
    }

    function selectMusic(selected) {
        music.value = selected;
        stage.value = 'intro';
    }

    function startGame() {
        stage.value = 'game_start';
    }

    function endGame() {
        stage.value = 'game_end';
    }

    function endScreen() {
        stage.value = 'outro';
    }

    function replay() {
        stage.value = 'selectCharacter';
    }

</script>
